export default __webpack_public_path__ + "static/media/empty.1bb7a7e7.png";